// extracted by mini-css-extract-plugin
export default {"adminGreeting":"Greeting_adminGreeting__FF3tg"};